import { Controller, type UseFormReturn } from 'react-hook-form'

import { CardCheckbox } from '@/components/ui/CardCheckbox'
import { FieldError } from '@/components/ui/field'
import { FillFieldKey, useFieldCheck } from '@/models/fillApplication'
import type { TravelDistanceItem } from '../../models/user'
import type { TravelDistanceValues } from './useTravelDistanceForm'

interface TravelDistanceFieldsProps {
  form: UseFormReturn<TravelDistanceValues>
  options: TravelDistanceItem[]
}

export function TravelDistanceFields({ form, options }: TravelDistanceFieldsProps) {
  const check = useFieldCheck(FillFieldKey.TRAVEL_DISTANCE)

  return (
    <Controller
      name="travelDistance"
      control={form.control}
      render={({ field, fieldState }) => (
        <div className="flex flex-col gap-2" data-fill-field={FillFieldKey.TRAVEL_DISTANCE}>
          {options.map((option) => (
            <CardCheckbox
              key={option.value}
              isChecked={field.value.includes(option.value)}
              onChange={(checked) =>
                field.onChange(
                  checked
                    ? [...field.value, option.value]
                    : field.value.filter((value) => value !== option.value)
                )
              }
            >
              {option.emoji} {option.label}
            </CardCheckbox>
          ))}
          <FieldError>{fieldState.error?.message ?? check}</FieldError>
        </div>
      )}
    />
  )
}
